var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-o-section-cards"},[_c('div',{staticClass:"o-grid o-grid--25-25-25-25"},_vm._l((_vm.content.linked_posts),function(item,index){return _c('div',{key:index,staticClass:"o-grid__block"},[_c('card',{attrs:{"card":item,"horizontalLayout":false}})],1)}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6519de80","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/organisms/page-sections/OrganismSectionCards.vue
// module id = 1135
// module chunks = 0